var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisuelDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visuel/day") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visuel/day",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#DDD3F1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "tabler:sun-moon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(2.000000, 2.000000)",
    stroke: "#5A2C71",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11533333,7.88666667 C3.4416495,7.21298286 3.17854601,6.2310673 3.4251314,5.31079808 C3.67171679,4.39052887 4.39052887,3.67171679 5.31079808,3.4251314 C6.2310673,3.17854601 7.21298286,3.4416495 7.88666667,4.11533333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52933333,6.47133333 L5.64533333,6.636 C7.00177448,8.47007027 9.42760139,9.15352541 11.542,8.29733333 C10.7737109,10.1460607 9.13395722,11.4897948 7.17030252,11.879822 C5.20664783,12.2698493 3.1778302,11.6547783 1.76133333,10.24 M0,6 L0.666666667,6 M6,0 L6,0.666666667 M1.73333333,1.73333333 L2.2,2.2 M0,12 L12,0",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisuelDay);
export default __webpack_public_path__ + "static/media/visuel_day.3bebb1b1812f45ecdc2feba7977bfe42.svg";
export { ForwardRef as ReactComponent };